module.exports = __webpack_public_path__ + "static/media/box-sign.b5b70694.png";